import React, { type FunctionComponent } from 'react'
import { TextField } from 'ic-snacks'
import { type FormikProps } from 'formik'
import { type NewProductFormValues } from 'legacy/routes/catalog/types/product.types'
import FormSection from './FormSection'
import FormField from './FormField'
import ProductTypeInfoModal from './ProductTypeInfoModal'

interface Props extends FormikProps<NewProductFormValues> {}

export const NewProductInfo: FunctionComponent<Props> = ({
  handleChange,
  values,
  touched,
  errors,
}) => {
  return (
    <FormSection
      titleId="catalog.product.info"
      renderAction={() => (values.editable ? null : <ProductTypeInfoModal />)}
    >
      <FormField>
        <TextField
          name="name"
          value={values.name}
          onChange={handleChange}
          disabled={!values.editable}
          isValid={!touched.name || !errors.name}
          hasError={Boolean(touched.name && errors.name)}
          validationErrorText={errors.name}
          floatingLabelText="Product Name"
          autoComplete="off"
          fullWidth
        />
      </FormField>
      <FormField>
        <TextField
          name="brandName"
          value={values.brandName}
          onChange={handleChange}
          isValid={!touched.brandName || !errors.brandName}
          hasError={Boolean(touched.brandName && errors.brandName)}
          validationErrorText={errors.brandName}
          floatingLabelText="Brand Name"
          autoComplete="off"
          fullWidth
        />
      </FormField>
      <FormField>
        <TextField
          name="size"
          value={values.size}
          onChange={handleChange}
          isValid={!touched.size || !errors.size}
          hasError={Boolean(touched.size && errors.size)}
          validationErrorText={errors.size}
          floatingLabelText="Size"
          autoComplete="off"
          fullWidth
        />
      </FormField>
    </FormSection>
  )
}
